import type { CmlContent as NaptimeCmlContent } from 'bundles/cml';
import type {
  CmlContentInput,
  CommentContent,
} from 'bundles/grading/components/staff-graded-assignments/reusable-comments/api/types';

/**
 * Convert "Reusable Comment" CommentContent to NaptimeCml
 * @param content CommentContent
 * @returns NaptimeCmlContent
 */
export const commentToNaptimeCml = (content: CommentContent): NaptimeCmlContent => {
  return {
    typeName: 'cml',
    definition: {
      dtdId: content.dtdId,
      value: content.cmlValue,
    },
  };
};

/**
 * Convert NaptimeCml to "Reusable Comment" CmlContentInput
 * @param cml NaptimeCmlContent
 * @returns CmlContentInput
 */
export const naptimeCmlToContentInput = (cml: NaptimeCmlContent): CmlContentInput => {
  return {
    dtdId: cml.definition.dtdId,
    cmlValue: cml.definition.value,
  };
};

export const KEY_EVENT = {
  SPACE: { keyCode: 32, code: 'Space', key: 'Space' },
  ENTER: { keyCode: 13, code: 'Enter', key: 'Enter' },
  TAB: { keyCode: 9, code: 'Tab', key: 'Tab' },
  ARROW_UP: { keyCode: 38, code: 'ArrowUp', key: 'ArrowUp' },
  ARROW_DOWN: { keyCode: 40, code: 'ArrowDown', key: 'ArrowDown' },
};
